<template>
  <b-modal :id="modalId" size="xl" scrollable hide-footer
           :title="title" @shown="fetchContent" @hidden="reset">
    <div v-if="loading" style="min-height: 80vh; display: flex; align-items: center; justify-content: center;">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
    <div v-else v-html="content" class="docs"></div>
  </b-modal>
</template>

<script>
import {axios} from "@/utils"

export default {
  name: "ModalPolicyText",
  props: {
    modalId: {type: String, default: "bv-modal-policy"}
  },
  data() {
    return {
      title: '',
      url: '',
      content: '',
      loading: false
    }
  },
  methods: {
    open(url, title = '') {
      const separator = url.includes('?') ? '&' : '?'
      this.url = `${url}${separator}format=json`
      this.title = title
      this.$bvModal.show(this.modalId)
    },
    fetchContent() {
      if (!this.url) return
      this.loading = true
      axios
        .get(this.url)
        .then(({data}) => {
          this.title = data.page_title || this.title
          this.content = data.page_content
        })
        .finally(() => {
          this.loading = false
        })
    },
    reset() {
      this.content = ''
      this.title = ''
      this.url = ''
    }
  }
}
</script>
